import { action } from 'satcheljs';
import type { CalendarReadFormInitializationConfig } from 'owa-calendar-helpers-types/lib/CalendarReadFormInitializationConfig';
import type UnifiedTelemetryContext from 'owa-calendar-unified-telemetry-utils/lib/types/UnifiedTelemetryContext';

export interface LaunchCalendarReadingPaneActionMessage {
    config: CalendarReadFormInitializationConfig;
    targetWindow: Window | undefined;
    freezeDryId: string | undefined;
    popOutClickTime: number | undefined;
    openInNewWindow: boolean | undefined;
    unifiedTelemetryContext?: UnifiedTelemetryContext;
}
export const launchCalendarReadingPane: (
    config: CalendarReadFormInitializationConfig,
    targetWindow?: Window,
    freezeDryId?: string,
    popOutClickTime?: number,
    openInNewWindow?: boolean,
    unifiedTelemetryContext?: UnifiedTelemetryContext
) => LaunchCalendarReadingPaneActionMessage = action(
    'launchCalendarReadingPane',
    (
        config: CalendarReadFormInitializationConfig,
        targetWindow?: Window,
        freezeDryId?: string,
        popOutClickTime?: number,
        openInNewWindow?: boolean,
        unifiedTelemetryContext?: UnifiedTelemetryContext
    ): LaunchCalendarReadingPaneActionMessage => ({
        config,
        targetWindow,
        freezeDryId,
        popOutClickTime,
        openInNewWindow,
        unifiedTelemetryContext,
    })
);
